import styled, { css } from 'styled-components';

const createDisplay = (hide: boolean) => css`
  display: ${hide ? 'none' : 'flex'};
`;

const addMarginWhenNotEmpty = css`
  > div {
    margin-bottom: 16px;

    &:empty,
    &:has(> div:empty) {
      margin-bottom: 0;
    }
  }
`;

export const StyledAdv = styled.div`
  max-width: 100%;
  overflow: hidden;

  &#afs-results-bottom {
    overflow: visible;
    width: 100%;
  }
`;

export const TopLeaderboardContainer = styled.div<{ hide: boolean }>`
  ${({ hide }) => createDisplay(hide)}

  width: 100%;
  justify-content: center;
  margin-bottom: 16px;
`;

export const BottomLeaderboardContainer = styled.div<{ hide: boolean }>`
  ${({ hide }) => createDisplay(hide)}

  width: 100%;
  justify-content: center;

  .filters-bar-container + & {
    margin-top: 16px;
  }

  ${addMarginWhenNotEmpty};
`;

export const IntraListAdvContainer = styled.div<{ hide: boolean }>`
  ${({ hide }) => createDisplay(hide)}

  max-width: 100%;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  margin-bottom: 0 !important;

  ${addMarginWhenNotEmpty};

  > div > [style*='height:0'],
  > div > [style*='height: 0'] {
    margin-bottom: 0;
  }
`;

export const BottomDoubleMPUContainer = styled.div<{ hide: boolean }>`
  ${({ hide }) => createDisplay(hide)}

  width: 100%;
  column-gap: 16px;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const BottomDoubleMPULeftContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  @media (min-width: 768px) {
    width: 50%;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0;
  }
`;
export const BottomDoubleMPURightContainer = styled.div`
  display: flex;
  justify-content: center;

  @media (min-width: 768px) {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;
